import { DevelopmentEnvironmentState } from "./developmentEnvironmentState";
import { Actions, Action } from "./developmentEnvironmentActions";

export default (state: typeof DevelopmentEnvironmentState, action: Action): typeof DevelopmentEnvironmentState => {
  switch (action.type) {
    case Actions.SET_SHOW_LOCATION_STATE:
      return {
        ...state,
        showLocationState: action.payload,
      };
    case Actions.SET_SHOW_MENU:
      return {
        ...state,
        showMenu: action.payload,
      };
    case Actions.LOAD_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
